<template>
  <div>
    <customer-specific-prices-add
      :is-active="isModalActive"
      :customer-id="Number(this.$route.params.id)"
      :is-add="isAdd"
      :is-edit="isEdit"
      :action="action"
      :edit-object-name="editObjectName"
      @confirm="editConfirm"
      @cancel="editCancel"
      :country="countries"
      :container="containers"
      :scheme="schemes"
    />
    <customer-specific-prices-upload
      :is-active="uploadFees"
      :customer-id="Number(this.$route.params.id)"
      @close="uploadFees = false"
      @confirm="editConfirm"
    />

    <div class="level no-margin">
      <div class="level-left"></div>
      <div class="level-right" v-if="disableActionItem()">
        <div class="level-item-horizontal">
          <ul class="context-options-right">
            <li><a @click.prevent="addModal">Add new</a></li>
            <li>
              <a @click.prevent="uploadCustomerSpecificPriceUpload">Import</a>
            </li>
            <li>
              <a @click.prevent="exportCustomerSpecificPrices"
                >Export selected</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="enable-select-text">
      <circul8-table
        :records="data"
        :fields="columns"
        :routeNext="false"
        :usePropRecords="true"
        @clickcheck="checkCheckBox"
        @clickEdit="editModal"
        @clickView="viewModal"
        :infoPosition="0"
        @clickDelete="deleteModal"
        :showRemoveButton="showDelete"
        :showEditButton="showEdit"
        :isCheckable="true"
        :maxTextLength="'26'"
        :backendSortingEnabled="true"
        @querySet="searchByFilter"
        @backendSort="sortData"
        :allCountries="countries"
      />
    </div>
  </div>
</template>

<script>
import { forkJoin } from "rxjs";
import CustomerSpecificPricesAdd from "@/components/Customers/CustomerSpecificPricesAdd";
import CustomerSpecificPricesService from "@/services/CustomerSpecificPricesService";
import CustomerSpecificPricesUpload from "@/components/Customers/CustomerSpecificPricesUpload";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import Circul8Table from "../../components/Circul8Table.vue";
import utilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { Permission } from "../../services/Permissions";
import { mapGetters } from "vuex";

// @group Customers
export default {
  name: "CustomerSpecificPrices",
  mixins: [utilityMixin, ScopeMixin],
  components: {
    CustomerSpecificPricesAdd,
    CustomerSpecificPricesUpload,
    Circul8Table
  },

  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    contactAction: {
      type: Boolean,
      default: false
    },
    customerAccountManager: {
      type: Number,
      default: 0
    },
    backupCustomerAccountManager: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isModalActive: false,
      uploadFees: false,
      isAdd: false,
      isEdit: false,
      action: null,
      editObject: this.getClearFormObject(),
      tableHeight: "",
      users: [],
      checkedRow: [],
      data: [],
      customers: [],
      customerMap: {},
      columns: [
        {
          field: "customer",
          label: "Customer",
          type: "input",
          searchable: true,
          visible: true,
          filterKey: { customer: "" },
          width: "200"
        },
        {
          field: "country",
          label: "Country",
          searchable: true,
          width: "200",
          visible: true,
          searchKey: "country",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.countries,
          filterKey: { country: [] }
        },
        {
          field: "stream",
          label: "Stream",
          type: "multiSelectFilter",
          width: "200",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.stream,
          filterKey: { stream: [] }
        },
        {
          field: "scheme",
          label: "Scheme",
          width: "200",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.containers,
          filterKey: { scheme_name: "" }
        },
        {
          field: "reporting_main_category",
          label: "Reporting Main Category",
          searchable: true,
          type: "input",
          width: "300",
          visible: true,
          filterKey: { reporting_main_category: "" }
        },
        {
          field: "reporting_sub_category",
          label: "Reporting Sub Category",
          searchable: true,
          width: "300",
          type: "input",
          visible: true,
          filterKey: { reporting_sub_category: "" }
        },
        {
          field: "fee_per_kg",
          label: "Fee Per KG",
          searchable: true,
          width: "200",
          type: "input",
          visible: true,
          filterKey: { fee_per_kg: "" }
        },
        {
          field: "fee_per_unit",
          label: "Fee Per Unit",
          searchable: true,
          width: "200",
          type: "input",
          visible: true,
          filterKey: { fee_per_unit: "" }
        },
        {
          field: "valid_from",
          label: "Valid From",
          searchable: true,
          visible: true,
          dateField: true,
          type: "dateField",
          dateFilterKey: "valid_from_key",
          filterKey: { valid_from: [] }
        },
        {
          field: "valid_to",
          label: "Valid To",
          searchable: true,
          visible: true,
          dateField: true,
          type: "dateField",
          dateFilterKey: "valid_to_key",
          filterKey: { valid_to: [] }
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      query: "",
      lastSortColumn: null,
      lastSortOrder: null,
      responseData: [],
      customerSpecificPricesService: new CustomerSpecificPricesService(),

      customerDataService: new CustomerProfileDataService()
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    }
  },
  watch: {
    customerAccountManager(newValue) {
      //Watches value of CAM and triggers this function if value of CAM changes
      this.fetchCustomerSpecificPricesData();
    }
  },
  mounted() {
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    forkJoin(this.fetchCustomerList()).subscribe(parents => {
      this.fetchCustomerSpecificPricesData();
    });
  },

  methods: {
    checkCheckBox(d) {
      this.checkedRow = d;
    },
    searchByFilter(filterQuery) {
      this.data = [];
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchCustomerSpecificPricesData(query);
    },
    sortData(field, order) {
      this.data = [];
      // sort should always fetch page 1, so removing page param if exist
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchCustomerSpecificPricesData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query && this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },

    getClearFormObject() {
      return {
        id: null,
        customer: Number(this.$route.params.id),
        country: null,
        scheme: null,
        stream: null,
        reporting_category: null,
        reporting_sub_category: null,
        fee_per_kg: null,
        fee_per_unit: null,
        valid_from: null,
        valid_to: null
      };
    },
    addModal() {
      this.isAdd = true;
      this.isEdit = false;
      this.action = "Add";
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.isAdd = true;
      this.isEdit = true;
      this.action = "Update";
      const editData = this.responseData.filter(i => i.id == editObject.id);
      this.editObject = editData ? editData[0] : [];
      //this.fetchCustomerSpecificPriceSingleData(editObject);
      this.isModalActive = true;
    },
    viewModal(editObject) {
      this.isAdd = false;
      this.isEdit = false;
      this.action = "View";
      const editData = this.responseData.filter(i => i.id == editObject.id);
      this.editObject = editData ? editData[0] : [];
      this.isModalActive = true;
    },
    deleteModal(editObject) {
      //this.isAdd = false;
      //this.action = "Delete";
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to delete?",
        cancelText: "No",
        confirmText: "Yes",
        onConfirm: () => this.deleteCustomerSpecificPriceSingleData(editObject)
      });
      //this.isModalActive = true;
    },
    editConfirm(response) {
      this.fetchCustomerSpecificPricesData();
      this.isModalActive = false;
      this.checkedRow = [];
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    exportCustomerSpecificPrices() {
      try {
        const set = new Set(
          this.checkedRow.map(cc => cc.id).map(result => JSON.stringify(result))
        );
        this.customerSpecificPricesService.export(
          Array.from(set).map(elem => JSON.parse(elem)),
          Number(this.$route.params.id)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Upload Error !!!",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    uploadCustomerSpecificPriceUpload() {
      this.uploadFees = true;
    },

    fetchCustomerList() {
      const customerObservable = this.customerDataService.getCustomerList(
        this.customerId
      );
      customerObservable.subscribe(
        customerProfiles => {
          this.customers = customerProfiles;
          this.customerMap = this.prepareMasterData(this.customers);
        },
        e => {
          console.log(e);
        }
      );
      return customerObservable;
    },
    prepareData(data) {
      for (const report in data) {
        data[report]["customer"] = this.customerMap[data[report].customer];
        data[report]["country"] = this.countryMap[data[report].country];
        data[report]["stream"] = this.containerMap[data[report].stream];
        data[report]["scheme"] = this.schemeMap[data[report].scheme];
        data["valid_from"] = this.convertToDate(data[report].valid_from);
        data["valid_to"] = this.convertToDate(data[report].valid_to);
        data[report]["actions"] = this.isEditAllowed();
        data[report]["delete"] = this.isEditAllowed();
      }
      this.data = data;

      if (this.data.length >= 10) {
        this.tableHeight = "height:560px";
      }
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    handleApiError(reason) {
      const errorMessage = reason.response.data["detail"];

      if (errorMessage != null && errorMessage != undefined) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: errorMessage,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        this.fetchCustomerSpecificPricesData(this.query);
      }
    },
    fetchCustomerSpecificPriceSingleData(editObjectName) {
      this.customerSpecificPricesService
        .getAll(this.$route.params.id, editObjectName.id)
        .subscribe(response => {
          this.editObject = response;
        }, this.handleApiError);
    },
    deleteCustomerSpecificPriceSingleData(editObjectName) {
      this.customerSpecificPricesService
        .delete(editObjectName.id)
        .subscribe(response => {
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Customer Specific Fee Removed!"
          });
          this.fetchCustomerSpecificPricesData();
        }, this.handleApiError);
    },
    isEditAllowed() {
      if (this.$route.fullPath.includes("/view/")) {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
          (this.customerAccountManager == this.userId ||
            this.backupCustomerAccountManager == this.userId))
      ) {
        this.showDelete = true;
        this.showEdit = true;
        return true;
      } else {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
    },
    fetchCustomerSpecificPricesData(query = "") {
      this.isLoading = true;
      this.customerSpecificPricesService
        .getAll(this.$route.params.id, query)
        .subscribe(response => {
          this.responseData = JSON.parse(JSON.stringify(response));
          this.isLoading = false;
          this.prepareData(response);
        }, this.handleApiError);
    }
  }
};
</script>
